import React from 'react';
import { Language } from '../types';
import { Lock } from 'lucide-react';
import { getSiteBranding } from '../services/siteSettingsStorage';

interface FooterProps {
  currentLang: Language;
  onOpenLegal: (type: 'privacy' | 'terms') => void;
  onOpenAdmin?: () => void;
}

export const Footer: React.FC<FooterProps> = ({ currentLang, onOpenLegal, onOpenAdmin }) => {
  const branding = getSiteBranding();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 py-16">
      <div className="w-[90%] max-w-none mx-auto px-6 flex flex-col items-center justify-center text-center space-y-8">
        
        <h2 className="text-xl md:text-2xl font-bold tracking-widest text-white uppercase font-sans">
          {branding.companyName || 'CHERIF HADDAD'}
        </h2>
        
        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-slate-400">
          <button 
            onClick={(e) => { e.preventDefault(); onOpenLegal('privacy'); }} 
            className="hover:text-white transition-colors"
          >
            {currentLang === 'ar' ? 'سياسة الخصوصية' : currentLang === 'en' ? 'Privacy Policy' : 'Politique de Confidentialité'}
          </button>
          <button 
            onClick={(e) => { e.preventDefault(); onOpenLegal('terms'); }} 
            className="hover:text-white transition-colors"
          >
            {currentLang === 'ar' ? 'شروط الاستخدام' : currentLang === 'en' ? 'Terms of Service' : 'Conditions d\'Utilisation'}
          </button>
          <a href="https://www.linkedin.com/in/cherif-haddad-3589b358/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
            LinkedIn
          </a>
          <a href="#contact" className="hover:text-white transition-colors">
            {currentLang === 'ar' ? 'اتصل بنا' : currentLang === 'en' ? 'Contact' : 'Contact'}
          </a>
        </div>
        
        <div className="flex items-center gap-2 text-xs text-slate-500 justify-center">
          <p>
            {branding.footerCopyright.replace('{year}', currentYear.toString()) || `© ${currentYear} CHERIF HADDAD Consulting & Expertise. All rights reserved.`}
          </p>
          {onOpenAdmin && (
            <a href="/_sysadmin" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" title={currentLang === 'ar' ? 'لوحة التحكم والإدارة' : 'Administration'}>
              <Lock size={12} />
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};
